import { createServer } from 'miragejs';
import onboardingRoutes from 'mocks/miragejs/onboarding/onboarding';
import preSignupRoutes from 'mocks/miragejs/pre-signup/pre-signup';

/** SEE THE README.md */
export default () =>
  createServer({
    routes() {
      this.urlPrefix = 'http://localhost:3000';

      onboardingRoutes(this);
      preSignupRoutes(this);
    },
  });
